import { Component, computed, EventEmitter, Input, OnChanges, Output, signal, Signal, SimpleChanges, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BatchStock, BatchStockDTO, CompaniesWithBatchStocks, CompanyWithBatchStocks, StoreStock, StoreStocks } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { StockAndPriceService } from 'src/app/services/api/stock-and-price.service';
import { SharedService } from 'src/app/services/shared.service';
import { StockButtonComponent } from '../stock-button/stock-button.component';
import { BatchCardComponent } from '../../batch-stock/batch-card/batch-card.component';
import { MyStoreStockComponent } from '../my-store-stock/my-store-stock.component';
import { PdpService } from '../../pdp.service';

@Component({
  selector: 'app-hq-batch-stock',
  imports: [
    StockButtonComponent,
    BatchCardComponent,
    MyStoreStockComponent,
    SharedModule
  ],
  templateUrl: './hq-batch-stock.component.html',
  styleUrl: './hq-batch-stock.component.scss'
})
export class HqBatchStockComponent implements OnChanges {

  @Input('sapCode') sapCode!: string;
  @Input('hqBatchStock') hqBatchStock!: CompaniesWithBatchStocks;
  @Input('selectedArea') selectedArea: string | null = null;

  @Output('handleGoBackToAreaList') handleGoBackToAreaList: EventEmitter<void> = new EventEmitter<void>();

  private _companies: WritableSignal<CompaniesWithBatchStocks | null> = signal(null);
  public companies: Signal<CompaniesWithBatchStocks | null> = computed(() => this._companies());

  private _selectedCompany: WritableSignal<CompanyWithBatchStocks | null> = signal(null);
  public selectedCompany: Signal<CompanyWithBatchStocks | null> = computed(() => this._selectedCompany());

  public batchStocks: Signal<BatchStockDTO> = computed(() => {
    let selectedCompany = this._selectedCompany();
    if (selectedCompany && selectedCompany.batchStocks) {
      return selectedCompany.batchStocks || [];
    }
    return []
  });

  private _selectedBatch: WritableSignal<BatchStock | null> = signal(null);
  public selectedBatch: Signal<BatchStock | null> = computed(() => this._selectedBatch());
  public storeStock: Signal<StoreStock | null> = computed(() => this._selectedBatch()?.storeStocks || null);


  //Flag che determina quando devo mostrare l'elenco delle companies
  public get showCompanyList(): boolean {
    //Mostro le companies quando non ne ho ancora selezionata una
    return !this.selectedCompany();
  }

  //Flag che determina quando devo mostrare l'elenco dei stock batch
  public get showBatchStockList(): boolean {
    //Mostro glis tore quando ho selezionato una company ma non ho ancora selezionato uno store
    return !!this.selectedCompany() && !this.selectedBatch();
  }

  //Flag che determina quando devo mostrare lo stock dello store selezionato
  public get showStoreStock(): boolean {
    return !!this.selectedBatch();
  }

  constructor(
    public readonly pdpService: PdpService,
    public readonly sharedService: SharedService,
    public readonly stockAndPriceService: StockAndPriceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildCompanies(this.sapCode);
  }

  //TODO: Imitare hq-stock components con l'integrazione di pdpService

  /**
   * Costruisco l'array delle companies in modo che abbia solo gli store che contengono il sapcode
   * passato come parametro.
   * @param sapCode
   */
  buildCompanies(sapCode: string) {
    let selectedCompany: CompanyWithBatchStocks | null = this._selectedCompany();
    let companies: CompaniesWithBatchStocks = [];
    (JSON.parse(JSON.stringify(this.hqBatchStock)) as CompaniesWithBatchStocks).forEach(company => {
      // let stores = company?.batchStocks?.find(val => val.sapcode === sapCode);
      // if (stores) {
      //   company.batchStocks = [stores];
      // }
      companies.push(company);
    });
    this._companies.set(companies);
    // console.log('companies with batch stock', companies);
    this.handleSelectCompany(null);
    this.handleSelectCompany(selectedCompany);
  }

  handleSelectCompany(company: CompanyWithBatchStocks | null) {
    this._selectedCompany.set(company);
    // if(this.pdpService.initializedGlobalAreaBatchStock){
    //   this.pdpService.updateSizeCounters_forCompany(company)
    // }
  }

  handleSelectBatchStock(batchStock: BatchStock | null) {
    this._selectedBatch.set(batchStock);
  }

}
